import classNames from 'classnames';
import styles from './TitleColumn.module.css';

/**
 * Presents a title and a column of content which is indented under the column
 * @param {ReactNode | string} param.title The title of the column
 * @param {string} param.className Classname to modify the container styles
 * @param { string} param.titleClassName Classname to modify the title styles
 * @param {ReactNode} param.children The content of the column
 * @returns {ReactNode} The column
 */
export const TitleColumn = ({
	title,
	className,
	titleClassName,
	children
}: {
	title: React.ReactNode | string;
	className?: string;
	children: React.ReactNode;
	titleClassName?: string;
}) => {
	return (
		<div className={classNames(styles.container, className)}>
			<h2 className={classNames(titleClassName, styles.feedTitle)}>{title}</h2>
			<div className={styles.titleColumn}>{children}</div>
		</div>
	);
};
